import React from "react";

import {
  BodyTabs,
  BodyTabItem,
  BodyTabItemText,
  BodyTabItemDecoration,
} from "./styled";

export default function CampaingTabs({ active, setActive, tabs }) {
  return (
    <>
      <BodyTabs>
        {tabs?.map((item, key) => (
          <BodyTabItem key={key} onClick={() => setActive(item.value)}>
            <BodyTabItemText active={active === item.value}>
              {item.title}
            </BodyTabItemText>
            <BodyTabItemDecoration active={active === item.value} />
          </BodyTabItem>
        ))}
      </BodyTabs>
    </>
  );
}
